module.exports = ({ city, state, country }) =>
  city && state && country
    ? `${city}, ${state}, ${country}`
    : city && country
    ? `${city}, ${country}`
    : state && country
    ? `${state}, ${country}`
    : '';
